import { Icon, IconProps } from '@chakra-ui/react'

export const DraggableIcon: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon height={'12px'} width={'6px'} viewBox={'0 0 6 12'} {...props}>
      <circle cx="1" cy="1" r="1" fill="black" />
      <circle cx="1" cy="6" r="1" fill="black" />
      <circle cx="1" cy="11" r="1" fill="black" />
      <circle cx="5" cy="1" r="1" fill="black" />
      <circle cx="5" cy="6" r="1" fill="black" />
      <circle cx="5" cy="11" r="1" fill="black" />
    </Icon>
  )
}
